import { type MutationError, trpc } from '@/shared/api';

interface UseReorderLandingPartnersOptions {
  readonly onSuccess?: () => void;
}

/** 끌어다 놓은 결과를 전체 순서로 제출한다 — 서버가 현재 목록과 같은 집합인지 확인하고 0부터 다시 매긴다. */
export const useReorderLandingPartners = ({ onSuccess }: UseReorderLandingPartnersOptions = {}) => {
  const mutation = trpc.landing.reorderPartners.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    reorderItems: (orderedIds: readonly string[]) =>
      mutation.mutate({ orderedIds: [...orderedIds] }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
